import * as React from 'react';
import {
    Box, Button, Container, Dialog, DialogActions, DialogContent, DialogTitle,
    Grid2, MenuItem, Stack, TextField
} from '@mui/material';
import TableWithPagination from '../../BuiltInComponent/TableWithPagination'
import Loading from '../../BuiltInComponent/Loading'
import ModernNavbar from '../setup/ModernNavbar'
import HeadingText from '../../BuiltInComponent/HeadingTest'
import AutoComplete from '../../BuiltInComponent/AutoComplete';
import dayjs from 'dayjs';
import { useDispatch, useSelector } from 'react-redux';
import { getExits, getSingleExit, addExit, editExit, deleteExit } from '../../features/PayrollManagement/resignSlice'
import { getEmpListForAttendance } from '../../features/PayrollManagement/employeeSlice'
import { PDFViewer, PDFDownloadLink } from '@react-pdf/renderer';
import ExitLetterPDF from '../PayrollReports/ExitLetterPDF';


const defaultForm = {
    empID: '',
    exitType: 'Resignation',
    noticeDate: dayjs().format('YYYY-MM-DD'),
    lastWorkingDate: dayjs().add(30, 'day').format('YYYY-MM-DD'),
    reason: '',
    docUrl: '',
    remarks: '',
    statusID: 'Pending'
};

const statuses = [
    { statusID: 'Pending', statusName: 'Pending' },
    { statusID: 'Approved', statusName: 'Approved' },
    { statusID: 'Rejected', statusName: 'Rejected' },
    { statusID: 'Withdrawn', statusName: 'Withdrawn' },
]
export default function ExitRequestsPageTable() {

    const dispatch = useDispatch()

    const { isLoading } = useSelector(state => state.resign)
    const { empListForAtt } = useSelector(state => state.emp)

    // table data/pagination
    const [rows, setRows] = React.useState([]);

    // filters
    // const [filters, setFilters] = React.useState({ search: '', status: '', exitType: '' });

    // dialog/form
    const [open, setOpen] = React.useState(false);
    const [editRow, setEditRow] = React.useState(false);
    const [form, setForm] = React.useState({
        empID: '',
        exitType: 'Resignation',
        noticeDate: dayjs().format('YYYY-MM-DD'),
        lastWorkingDate: dayjs().add(30, 'day').format('YYYY-MM-DD'),
        reason: '',
        docUrl: '',
        remarks: '',
        statusID: 'Pending'
    });
    const [errors, setErrors] = React.useState({});

    const [openLetter, setOpenLetter] = React.useState(false);
    const [letterRow, setLetterRow] = React.useState(null);

    // company info (adjust as needed; yahan static diya hai)
    const company = {
        name: 'Maltex Exports',
        address: 'Office # 4, 17-C, Ittihad Lane 12, DHA Phase 2 Karachi, Pakistan',
        city: 'Karachi',
        country: 'Pakistan',
        phone: '+92-123-1234567',
        email: 'hr@maltexexports.com',
        website: 'https://maltexexports.com',
        // hrName: 'Tipu Sultan',
        hrTitle: 'HR & Admin'
    };

    const tableColumns = [
        { fieldName: 'exitID', cName: 'ID', textAlign: 'left', width: '10%', dType: 'string', status: 'en' },
        { fieldName: 'empID', cName: 'Emp ID', textAlign: 'left', width: '25%', dType: 'string', status: 'en' },
        { fieldName: 'empName', cName: 'Emp Name', textAlign: 'left', width: '20%', dType: 'string', status: 'en' },
        { fieldName: 'exitType', cName: 'Type', textAlign: 'left', width: '20%', dType: 'string', status: 'en' },
        { fieldName: 'noticeDate', cName: 'Notice Date', textAlign: 'left', width: '20%', dType: 'date', status: 'en' },
        { fieldName: 'lastWorkingDate', cName: 'Las Day', textAlign: 'left', width: '20%', dType: 'date', status: 'en' },
        { fieldName: 'reason', cName: 'Reason', textAlign: 'left', width: '20%', dType: 'string', status: 'en' },
        { fieldName: 'status', cName: 'Status', textAlign: 'left', width: '20%', dType: 'string', status: 'en' },
        { fieldName: 'remarks', cName: 'Remarks', textAlign: 'left', width: '20%', dType: 'string', status: 'en' },
        { fieldName: 'edit', cName: 'Edit', textAlign: 'center', width: '5%', status: 'en' },
        { fieldName: 'delete', cName: 'Delete', textAlign: 'center', width: '5%', status: 'en' },
        { fieldName: 'delete', cName: 'Delete', textAlign: 'center', width: '5%', status: 'en', buttonText: "Print" },
    ]

    React.useEffect(() => {
        dispatch(getExits()).then((res) => {
            setRows(res.payload)
        })
        dispatch(getEmpListForAttendance())
    }, [dispatch]);

    // actions
    const onAdd = () => {
        setEditRow(null);
        setForm(defaultForm);
        setErrors({});
        setOpen(true);
    };

    const onEditClick = (id) => {
        dispatch(getSingleExit(id)).then((res) => {
            setForm(prev => ({
                ...prev,
                exitID: res.payload.exitID,
                empID: res.payload.empID ?? '',
                exitType: res.payload.exitType ?? 'Resignation',
                noticeDate: dayjs(res.payload.noticeDate).format('YYYY-MM-DD'),
                lastWorkingDate: dayjs(res.payload.lastWorkingDate).format('YYYY-MM-DD'),
                statusID: res.payload.status,
                reason: res.payload.reason || '',
                remarks: res.payload.remarks || ''
            }));

        })
        setEditRow(true);
        setErrors({});
        setOpen(true);
    };

    const onDeleteClick = async (id) => {
        dispatch(deleteExit(id)).then(() => {
            dispatch(getExits()).then((res) => {
                setRows(res.payload)
            })
        })

    };

    const validate = () => {
        const e = {};
        if (!form.empID) e.empID = 'Required';
        if (!form.exitType) e.exitType = 'Required';
        if (!form.noticeDate) e.noticeDate = 'Required';
        if (!form.lastWorkingDate) e.lastWorkingDate = 'Required';
        setErrors(e);
        return Object.keys(e).length === 0;
    };

    const onSubmit = async (evt) => {
        evt.preventDefault();
        if (!validate()) return;
        try {
            if (editRow) {
                dispatch(editExit(form)).then(() => {
                    dispatch(getExits()).then((res) => {
                        setRows(res.payload)
                    })
                })
            } else {
                dispatch(addExit(form)).then(() => {
                    dispatch(getExits()).then((res) => {
                        setRows(res.payload)
                    })
                })
            }
            setOpen(false);
            dispatch(getExits()).then((res) => {
                setRows(res.payload)
            })
        } catch (e) {
            alert(e.message);
        }
    };

    // handlers
    const handleChange = (field) => (e) => setForm((f) => ({ ...f, [field]: e.target.value }));

    const handleEmpChange = (data) => {
        if (data) {
            setForm(prev => ({ ...prev, empID: data.empID }))
        } else {
            setForm(prev => ({ ...prev, empID: '' }))
        }
    }

    const handleDeptChange = (data) => {
        const keys = Object.keys(data)
        if (keys[0] === 'statusID') {
            setForm(prev => ({ ...prev, status: data[keys] }))
        }
    }
    const [norLoading, setNorLoading] = React.useState(false)

    const onButtonClick = async (id) => {
        setNorLoading(true)
        dispatch(getSingleExit(id)).then((res) => {
            setForm(prev => ({
                ...prev,
                exitID: res.payload.exitID,
                empID: res.payload.empID ?? '',
                exitType: res.payload.exitType ?? 'Resignation',
                noticeDate: dayjs(res.payload.noticeDate).format('YYYY-MM-DD'),
                lastWorkingDate: dayjs(res.payload.lastWorkingDate).format('YYYY-MM-DD'),
                statusID: res.payload.status,
                reason: res.payload.reason || '',
                remarks: res.payload.remarks || ''
            }));
            setLetterRow(res.payload)
            setNorLoading(false)
        })
        setOpenLetter(true);
    }

    return (
        <>
            <ModernNavbar />
            <Container maxWidth="xl" sx={{ py: 3 }}>
                <Grid2 container spacing={2}>
                    <Grid2 size={3}></Grid2>
                    <Grid2 size={6}><HeadingText text="Exit Requests (Resignation / Termination)" /></Grid2>
                    <Grid2 size={3}></Grid2>
                </Grid2>
                <Stack direction="row" justifyContent="flex-end" alignItems="center" mb={2}>
                    <Button variant="contained" onClick={onAdd} style={{ width: 150 }}>Add New</Button>
                </Stack>

                {/* Filters */}
                {/* <Stack direction="row" spacing={2} mb={2}>
                    <TextField
                        size="small" label="Search" value={filters.search}
                        onChange={e => setFilters(s => ({ ...s, search: e.target.value }))}
                    />
                    <TextField
                        size="small" label="Status" select value={filters.status}
                        onChange={e => setFilters(s => ({ ...s, status: e.target.value }))} sx={{ minWidth: 160 }}>
                        <MenuItem value="">All</MenuItem>
                        <MenuItem value="pending">Pending</MenuItem>
                        <MenuItem value="approved">Approved</MenuItem>
                        <MenuItem value="rejected">Rejected</MenuItem>
                        <MenuItem value="withdrawn">Withdrawn</MenuItem>
                    </TextField>
                    <TextField
                        size="small" label="Type" select value={filters.exitType}
                        onChange={e => setFilters(s => ({ ...s, exitType: e.target.value }))} sx={{ minWidth: 160 }}>
                        <MenuItem value="">All</MenuItem>
                        <MenuItem value="Resignation">Resignation</MenuItem>
                        <MenuItem value="Termination">Termination</MenuItem>
                    </TextField>
                </Stack> */}

                {/* Table */}
                {isLoading ?
                    <>
                        <Loading />
                    </> :
                    <>
                        <TableWithPagination
                            tableColumns={tableColumns}
                            tableData={rows}
                            onEditClick={onEditClick}
                            onDeleteClick={onDeleteClick}
                            onButtonClick={onButtonClick}
                        />

                    </>}

                {/* Dialog Form */}
                <Dialog open={open} onClose={() => setOpen(false)} maxWidth="md" fullWidth>
                    <DialogTitle>{editRow ? 'Edit Exit Request' : 'Add Exit Request'}</DialogTitle>
                    <DialogContent dividers>
                        <Box component="form" id="exit-form" onSubmit={onSubmit} sx={{ mt: 1 }}>
                            <Grid2 container spacing={2}>
                                <Grid2 size={6}>
                                    <AutoComplete
                                        listData={empListForAtt}
                                        label='Employee'
                                        value={empListForAtt && empListForAtt.find((c) => c.empID === form.empID)}
                                        onChange={handleEmpChange}
                                    />
                                </Grid2>
                                <Grid2 size={6}>
                                    <TextField
                                        label="Exit Type"
                                        select
                                        fullWidth
                                        size="small"
                                        value={form.exitType}
                                        onChange={handleChange('exitType')}
                                        error={!!errors.exitType}
                                        helperText={errors.exitType}
                                    >
                                        <MenuItem value="Resignation">Resignation</MenuItem>
                                        <MenuItem value="Termination">Termination</MenuItem>
                                    </TextField>
                                </Grid2>
                                <Grid2 size={6}>
                                    <TextField
                                        label="Notice Date"
                                        type="date"
                                        fullWidth
                                        size="small"
                                        InputLabelProps={{ shrink: true }}
                                        value={form.noticeDate}
                                        onChange={handleChange('noticeDate')}
                                        error={!!errors.noticeDate}
                                        helperText={errors.noticeDate}
                                    />
                                </Grid2>
                                <Grid2 size={6}>
                                    <TextField
                                        label="Last Working Date"
                                        type="date"
                                        fullWidth
                                        size="small"
                                        InputLabelProps={{ shrink: true }}
                                        value={form.lastWorkingDate}
                                        onChange={handleChange('lastWorkingDate')}
                                        error={!!errors.lastWorkingDate}
                                        helperText={errors.lastWorkingDate}
                                    />
                                </Grid2>
                                <Grid2 size={12}>
                                    <TextField
                                        label="Reason"
                                        fullWidth
                                        size="small"
                                        multiline
                                        rows={2}
                                        value={form.reason}
                                        onChange={handleChange('reason')}
                                    />
                                </Grid2>
                                <Grid2 size={6}>
                                    <AutoComplete
                                        listData={statuses}
                                        columnName={'deptDesc'}
                                        label={'Department'}
                                        value={statuses.find((c) => c.statusID === form.statusID)}
                                        // value={emp.deptDesc}
                                        onChange={handleDeptChange}
                                    />
                                    {/* 
                                    <TextField
                                        label="Exit Type"
                                        select
                                        fullWidth
                                        size="small"
                                        value={form.exitType}
                                        onChange={handleChange('exitType')}
                                        error={!!errors.exitType}
                                        helperText={errors.exitType}
                                    >
                                        <MenuItem value="Resignation">Pending</MenuItem>
                                        <MenuItem value="Termination">Approved</MenuItem>
                                        <MenuItem value="Termination">Rejected</MenuItem>
                                        <MenuItem value="Termination">Withdrawn</MenuItem>
                                    </TextField> */}

                                    {/* <TextField
                                        label="Document URL"
                                        fullWidth
                                        size="small"
                                        value={form.docUrl}
                                        onChange={handleChange('docUrl')}
                                    /> */}
                                </Grid2>
                                <Grid2 size={6}>
                                    <TextField
                                        label="Remarks (HR)"
                                        fullWidth
                                        size="small"
                                        value={form.remarks}
                                        onChange={handleChange('remarks')}
                                    />
                                </Grid2>
                            </Grid2>
                        </Box>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={() => setOpen(false)}>Close</Button>
                        <Button type="submit" form="exit-form" variant="contained">
                            {editRow ? 'Update' : 'Save'}
                        </Button>
                    </DialogActions>
                </Dialog>
                {/* Report Section Starts */}
                <Dialog open={openLetter} onClose={() => setOpenLetter(false)} maxWidth="md" fullWidth>
                    <DialogTitle>Preview Letter — {letterRow?.exitType || ''}</DialogTitle>
                    <DialogContent dividers>
                        {norLoading ?
                            <>
                                <Loading />
                            </> : <>
                                {letterRow && (
                                    <PDFViewer style={{ width: '100%', height: 600 }}>
                                        <ExitLetterPDF record={letterRow} company={company} />
                                    </PDFViewer>
                                )}
                            </>}
                    </DialogContent>
                    <DialogActions>
                        {norLoading ?
                            <>
                                <Loading />
                            </> : <>
                                {letterRow && (
                                    <PDFDownloadLink
                                        document={<ExitLetterPDF record={letterRow} company={company} />}
                                        fileName={`Exit_Letter_${letterRow.exitID}_${letterRow.exitType}.pdf`}
                                        style={{ textDecoration: 'none' }}
                                    >
                                        {({ loading }) => (
                                            <Button variant="contained" disabled={loading}>
                                                {loading ? 'Preparing…' : 'Download'}
                                            </Button>
                                        )}
                                    </PDFDownloadLink>
                                )}
                            </>}
                        <Button onClick={() => setOpenLetter(false)}>Close</Button>
                    </DialogActions>
                </Dialog>
                {/* Report Section Ends */}
            </Container>
        </>
    );
}
